import React from 'react';
import PropTypes from 'prop-types';
import './notification.css';

function computeTrainingInitials(trainingName) {
  const raw = typeof trainingName === 'string' ? trainingName.trim() : '';
  if (!raw) return '';
  const compact = raw.replace(/\s+/g, '');
  return compact.slice(0, 2).toUpperCase();
}

function computeInitials({ name, firstName, lastName }) {
  const safe = (s) => (typeof s === 'string' ? s.trim() : '');
  const f = safe(firstName);
  const l = safe(lastName);
  const n = safe(name);

  if (f && l) return (f[0] + l[0]).toUpperCase();
  if (f && !l) return (f.slice(0, 2)).toUpperCase();

  if (n) {
    const parts = n.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return (parts[0].slice(0, 2)).toUpperCase();
  }
  return 'US'; // default "User"
}

function sanitizeHtml(html) {
  if (!html || typeof html !== 'string') return '';
  // Very light sanitizer: strip <script> tags and inline event handlers.
  // For production-grade safety, use DOMPurify.
  let cleaned = html.replace(/<\s*script[^>]*>.*?<\s*\/\s*script\s*>/gis, '');
  cleaned = cleaned.replace(/on[a-z]+\s*=\s*"[^"]*"/gi, '');
  cleaned = cleaned.replace(/on[a-z]+\s*=\s*'[^']*'/gi, '');
  cleaned = cleaned.replace(/javascript:\s*/gi, '');
  return cleaned;
}

export default function NotificationCard({
  avatarUrl,
  trainingName = '',
  firstName,
  lastName,
  name = '',
  topic = '',
  time = '',

  headline = '',
  htmlContent = '',

  onClick,
  showUnreadDot = false,
  showAvatarStroke = true,
  taskComplete = false,
  onClose,
}) {
  const hasAvatar = typeof avatarUrl === 'string' && avatarUrl.trim().length > 0;

  const trainingInitials = computeTrainingInitials(trainingName);
  const userInitials = computeInitials({ name, firstName, lastName });
  const avatarText = trainingInitials || userInitials;

  const imgAlt = trainingName
    ? `${trainingName} image`
    : (name || firstName) ? `${name || firstName} avatar` : 'User avatar';

  const initialsAriaLabel = trainingName
    ? `${trainingName} initials`
    : (name || firstName) ? `${name || firstName} initials avatar` : 'User initials avatar';

  return (

  <div className=" card-wrap">
     <div className="notif-avatar-wrap">
        {hasAvatar ? (
          <img
            className="notif-avatar"
            style={{ borderColor: showAvatarStroke ? '#ffffff' : 'transparent' }}
            src={avatarUrl}
            alt=''
          />
        ) : (
          <div
            className="notif-avatar notif-avatar-initials"
            style={{ borderColor: showAvatarStroke ? '#ffffff' : 'transparent' }}
            role="img"
            aria-label={initialsAriaLabel}
          >
            {avatarText}
          </div>
        )}
      </div>
      <div className="notif-content">
       {htmlContent ? (
          <div className="notif-html" dangerouslySetInnerHTML={{ __html: sanitizeHtml(htmlContent) }} />
        ) : (
          <p className="notif-text">
          No Value found.
          </p>
        )}
      </div>
  </div>

  );
}

NotificationCard.propTypes = {
  avatarUrl: PropTypes.string,
  trainingName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  name: PropTypes.string,
  topic: PropTypes.string,
  time: PropTypes.string,
  headline: PropTypes.string,
  htmlContent: PropTypes.string,
  onClick: PropTypes.func,

  showUnreadDot: PropTypes.bool,
  showAvatarStroke: PropTypes.bool,
  taskComplete: PropTypes.bool,
  onClose: PropTypes.func,
};
